import React from 'react';
import styled from 'styled-components';
import { Col } from '@cuemath/comps';
import PropTypes from 'prop-types';

import COMPS_COLORS from 'constants/colors';
import ninjaAvatar from 'img/left-nav/ninja-avatar.svg';
import maleTeacherAvatar from 'img/male.png';
import femaleTeacherAvatar from 'img/female.png';

const TeacherWrapper = styled(Col)`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-image: url(${({ gender }) =>
    gender === 'MALE' ? maleTeacherAvatar : femaleTeacherAvatar});
  background-color: ${COMPS_COLORS.WHITE};
  background-repeat: no-repeat;
  background-size: cover;
  border-style: solid;
  border-width: 1px;
  border-color: rgb(21, 123, 251);
  box-shadow: 2px 2px 2px 0 rgba(33, 92, 91, 0.31);
`;

const NewTeacherWrapper = styled(Col)`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-image: url(${ninjaAvatar});
  background-color: ${({ selected }) => (selected ? COMPS_COLORS.ORANGE : `#C4C4C4`)};
  background-repeat: no-repeat;
  background-size: 32px 32px;
  background-position: center;
  border-style: solid;
  border-width: 1px;
  border-color: ${COMPS_COLORS.COLA};
  right: 5px;
  padding: 0px;
  cursor: pointer;
`;

function TeacherAvatar({ enableTeacherRevamp, selected, gender }) {
  return enableTeacherRevamp ? (
    <NewTeacherWrapper selected={selected} gender={gender} />
  ) : (
    <TeacherWrapper gender={gender} />
  );
}

TeacherAvatar.propTypes = {
  gender: PropTypes.string,
};

TeacherAvatar.defaultProps = {
  gender: 'FEMALE',
};

export default TeacherAvatar;
